import React from 'react';
import { useModel } from '@/context/AuthContext';
import { usePermissionOverlay } from '@/context/PermissionOverlayContext';
import { PermissionBadge } from '@/components/PermissionOverlay';

export enum ModuleName {
  '*' = '*',
  'USER' = 'USER',
  'SECURITIES' = 'SECURITIES',
  'STATEMENTS' = 'STATEMENTS',
  'FIAT' = 'FIAT',
  'DIGITAL' = 'DIGITAL',
  'INSURANCE' = 'INSURANCE',
  'COMMODITY' = 'COMMODITY',
  'TREASURY' = 'TREASURY',
  'OPERATOR' = 'OPERATOR',
  'PENDING_PAYMENT' = 'PENDING_PAYMENT',
  'KYC' = 'KYC',
  'GENERAL_INSTRUCTION' = 'GENERAL_INSTRUCTION',
  'FEE_PAYOUT' = 'FEE_PAYOUT',
  'TRANSFER' = 'TRANSFER',
  'BILL_PAYMENT' = 'BILL_PAYMENT',
  'TAG_MANAGEMENT' = 'TAG_MANAGEMENT',
  'INVITATION_CODE' = 'INVITATION_CODE',
  'BENEFICIARIES' = 'BENEFICIARIES',
  'REPORTING' = 'REPORTING',
  'ACCOUNTING_REPORT' = 'ACCOUNTING_REPORT',
  'JOURNAL_REPORT' = 'JOURNAL_REPORT',
  'REPORTING_HISTORY' = 'REPORTING_HISTORY',
  'CMS_CARD' = 'CMS_CARD',
  'CMS_CREDIT' = 'CMS_CREDIT',
  'CMS' = 'CMS',
  'ISSUER_CARD_KYC' = 'ISSUER_CARD_KYC',
  'CARD_KYC_TRACKING' = 'CARD_KYC_TRACKING',
  'ALTERNATIVES' = 'ALTERNATIVES',
  'VENDOR' = 'VENDOR',
  'RELATIONSHIP_MANAGER' = 'RELATIONSHIP_MANAGER',
  'CARD_FRAUD_SYSTEM' = 'CARD_FRAUD_SYSTEM',
  'REPAYMENT' = 'REPAYMENT',
  'EXCHANGE' = 'EXCHANGE',
  'CLIENT_DOCUMENT' = 'CLIENT_DOCUMENT',
  'ALL_INSTRUCTION' = 'ALL_INSTRUCTION',
  'SCHEDULED_INSTRUCTION' = 'SCHEDULED_INSTRUCTION',
  'WALLET' = 'WALLET',
  'REVENUE' = 'REVENUE',
  'CASE' = 'CASE',
  'RATE_SOURCE' = 'RATE_SOURCE',
  'REMARK' = 'REMARK',
  'NFT' = 'NFT',
  'PURCHASE_ORDER' = 'PURCHASE_ORDER',
  'EARN' = 'EARN',
  'NAME_CHECK' = 'NAME_CHECK',
  'CARD_NAME_CHECK' = 'CARD_NAME_CHECK',
  'DEPOSIT_ADDRESSES' = 'DEPOSIT_ADDRESSES',
  'BANK_ACCOUNTS' = 'BANK_ACCOUNTS',
  'PAYMENT_DETAILS' = 'PAYMENT_DETAILS',
  'SOLUTION' = 'SOLUTION',
  'CASH_IN_OUT' = 'CASH_IN_OUT',
  'WORLD_PAY' = 'WORLD_PAY',
  'BOOK_ENTRIES' = 'BOOK_ENTRIES',
  'LEDGER_ACCOUNT' = 'LEDGER_ACCOUNT',
  'JOURNAL_ENTRIES' = 'JOURNAL_ENTRIES',
  'BANK_AVAILABLE_BALANCE' = 'BANK_AVAILABLE_BALANCE',
  'ACCOUNTING_TAG' = 'ACCOUNTING_TAG',
  'SALES_REVENUE_SUMMARY' = 'SALES_REVENUE_SUMMARY',
  'OD_ACCOUNT' = 'OD_ACCOUNT',
  'APPROVAL_REQUEST' = 'APPROVAL_REQUEST',
  'UNIONPAY_REMITTANCE' = 'UNIONPAY_REMITTANCE',
  'ALIPAY_REMITTANCE' = 'ALIPAY_REMITTANCE',
  'AGENT_ONBOARDING' = 'AGENT_ONBOARDING',
  'ACCOUNTING' = 'ACCOUNTING',
  'TRANSFER_PEER' = 'TRANSFER_PEER',
  'INTERNAL_ACCOUNT' = 'INTERNAL_ACCOUNT',
  'COMMISSION_DETAILS' = 'COMMISSION_DETAILS',
  'REVENUE_BREAKDOWN' = 'REVENUE_BREAKDOWN',
  'RISK_PROFILE' = 'RISK_PROFILE',
  'PRECIOUS_METAL' = 'PRECIOUS_METAL',
  'CASHIER' = 'CASHIER',
  'OPERATIONAL_ACCOUNTS' = 'OPERATIONAL_ACCOUNTS',
  'SUPPORT_CENTER' = 'SUPPORT_CENTER',
  'IFAST_FUND' = 'IFAST_FUND',
  'DEVELOPER' = 'DEVELOPER',
  'BLACKLIST_MERCHANT' = 'BLACKLIST_MERCHANT',
  'CARD_MERCHANT_WHITELIST' = 'CARD_MERCHANT_WHITELIST',
  'COMPLIANCE' = 'COMPLIANCE',
  'UNIGROUP_BOOK_MANAGEMENT' = 'UNIGROUP_BOOK_MANAGEMENT',
  'DIGITAL_ASSET_TREASURY' = 'DIGITAL_ASSET_TREASURY',
  'VENDOR_CONFIG' = 'VENDOR_CONFIG',
  'SENSITIVE_CARD_REPORT' = 'SENSITIVE_CARD_REPORT',
  'SECRET_MANAGEMENT' = 'SECRET_MANAGEMENT',
  'PI_QUALIFICATION' = 'PI_QUALIFICATION',
  'CLIENT_CONSENT' = 'CLIENT_CONSENT',
  'PDF_TEMPLATE' = 'PDF_TEMPLATE',
  'APP_DISCLOSURE' = 'APP_DISCLOSURE',
  'APP_WHATS_NEW' = 'APP_WHATS_NEW',
  'APP_IMPORTANT_NOTICES' = 'APP_IMPORTANT_NOTICES',
  'APP_CARD_OFFERS' = 'APP_CARD_OFFERS',
  'SYSTEM_NOTICE_EMAIL' = 'SYSTEM_NOTICE_EMAIL',
  'WELCOME_EMAIL_TEMPLATE' = 'WELCOME_EMAIL_TEMPLATE',
  'CS_TELEGRAM_BOT' = 'CS_TELEGRAM_BOT',
  'FEATURE_FLAG_RULES' = 'FEATURE_FLAG_RULES',
  'TRIBE_TAI' = 'TRIBE_TAI',
  'AUDIT_LOG' = 'AUDIT_LOG'
}

export enum PermissionType {
  'ROLE' = 'ROLE',
  'ACTION' = 'ACTION'
}

export enum PermissionRole {
  '*' = '*',
  'READ' = 'READ',
  'WRITE' = 'WRITE'
}

export enum PermissionVerbAction {
  'VIEW:*' = 'VIEW:*',
  'ACTION:*' = 'ACTION:*',
  'VIEW:PENDING_PAYMENT' = 'VIEW:PENDING_PAYMENT',
  'VIEW:KYC' = 'VIEW:KYC',
  'VIEW:BENEFICIARIES' = 'VIEW:BENEFICIARIES',
  'VIEW:CMS_CARD_PRODUCT' = 'VIEW:CMS_CARD_PRODUCT',
  'VIEW:CMS_CARD_PROGRAM' = 'VIEW:CMS_CARD_PROGRAM',
  'VIEW:WHITELIST_COBRAND_CARD_PRODUCTS' = 'VIEW:WHITELIST_COBRAND_CARD_PRODUCTS',
  'VIEW:CMS_CARD_TRANSACTIONS' = 'VIEW:CMS_CARD_TRANSACTIONS',
  'VIEW:CMS_CARD_REPAYMENT' = 'VIEW:CMS_CARD_REPAYMENT',
  'VIEW:CMS_CREDIT_ACCOUNT' = 'VIEW:CMS_CREDIT_ACCOUNT',
  'VIEW:VENDOR' = 'VIEW:VENDOR',
  'VIEW:GENERAL_INSTRUCTION' = 'VIEW:GENERAL_INSTRUCTION',
  'VIEW:FIAT_WITHDRAW' = 'VIEW:FIAT_WITHDRAW',
  'VIEW:FIAT_DEPOSIT' = 'VIEW:FIAT_DEPOSIT',
  'VIEW:DIGITAL_WITHDRAW' = 'VIEW:DIGITAL_WITHDRAW',
  'VIEW:DIGITAL_DEPOSIT' = 'VIEW:DIGITAL_DEPOSIT',
  'VIEW:DIGITAL_DEPOSIT_PENDING' = 'VIEW:DIGITAL_DEPOSIT_PENDING',
  'VIEW:TRANSFER' = 'VIEW:TRANSFER',
  'VIEW:BILL_PAYMENT' = 'VIEW:BILL_PAYMENT',
  'VIEW:SECURITIES' = 'VIEW:SECURITIES',
  'VIEW:SECURITIES_ACCOUNTS_LIST' = 'VIEW:SECURITIES_ACCOUNTS_LIST',
  'VIEW:STATEMENTS' = 'VIEW:STATEMENTS',
  'VIEW:ALTERNATIVES' = 'VIEW:ALTERNATIVES',
  'VIEW:ALTERNATIVES_OVERVIEW' = 'VIEW:ALTERNATIVES_OVERVIEW',
  'VIEW:INSURANCE' = 'VIEW:INSURANCE',
  'VIEW:INSURANCE_OVERVIEW' = 'VIEW:INSURANCE_OVERVIEW',
  'VIEW:INSURANCE_COMPANY' = 'VIEW:INSURANCE_COMPANY',
  'ACTION:CREATE_INSURANCE_COMPANY' = 'ACTION:CREATE_INSURANCE_COMPANY',
  'ACTION:EDIT_INSURANCE_COMPANY' = 'ACTION:EDIT_INSURANCE_COMPANY',
  'ACTION:DELETE_INSURANCE_COMPANY' = 'ACTION:DELETE_INSURANCE_COMPANY',
  'VIEW:INVITATION_CODE' = 'VIEW:INVITATION_CODE',
  'VIEW:CASH_INVENTORY' = 'VIEW:CASH_INVENTORY',
  'VIEW:OPERATOR' = 'VIEW:OPERATOR',
  'VIEW:USER' = 'VIEW:USER',
  'VIEW:USER_MIGRATION_CAMPAIGN' = 'VIEW:USER_MIGRATION_CAMPAIGN',
  'VIEW:USER_NOTION_PAGE' = 'VIEW:USER_NOTION_PAGE',
  'VIEW:USER_CONTACT' = 'VIEW:USER_CONTACT',
  'VIEW:RESTRICTED_CLIENT_SENSITIVE_DATA' = 'VIEW:RESTRICTED_CLIENT_SENSITIVE_DATA',
  'VIEW:REPORTING' = 'VIEW:REPORTING',
  'ACTION:MANAGE_REPORT_CONFIGURATION' = 'ACTION:MANAGE_REPORT_CONFIGURATION',
  'VIEW:COBRANDER_PNL_REPORT' = 'VIEW:COBRANDER_PNL_REPORT',
  'ACTION:PREPARE_COBRANDER_PNL_REPORT' = 'ACTION:PREPARE_COBRANDER_PNL_REPORT',
  'ACTION:APPROVE_COBRANDER_PNL_REPORT' = 'ACTION:APPROVE_COBRANDER_PNL_REPORT',
  'ACTION:EXPORT_COBRANDER_PNL_REPORT' = 'ACTION:EXPORT_COBRANDER_PNL_REPORT',
  'VIEW:ACCOUNTING_REPORT' = 'VIEW:ACCOUNTING_REPORT',
  'VIEW:JOURNAL_REPORT' = 'VIEW:JOURNAL_REPORT',
  'VIEW:UTGL_PNL_REPORT' = 'VIEW:UTGL_PNL_REPORT',
  'VIEW:UNIGROUP_CLIENT_ASSET_BALANCE' = 'VIEW:UNIGROUP_CLIENT_ASSET_BALANCE',
  'VIEW:BALANCE_SHEET' = 'VIEW:BALANCE_SHEET',
  'VIEW:REPORTING_HISTORY' = 'VIEW:REPORTING_HISTORY',
  'VIEW:REVENUE' = 'VIEW:REVENUE',
  'VIEW:CMS_CARD' = 'VIEW:CMS_CARD',
  'VIEW:CMS_CARD_ISSUE' = 'VIEW:CMS_CARD_ISSUE',
  'VIEW:CMS_CARD_APPLICATION' = 'VIEW:CMS_CARD_APPLICATION',
  'VIEW:CMS_CARD_RENEWAL' = 'VIEW:CMS_CARD_RENEWAL',
  'VIEW:CMS_PENDING_EMBOSSED' = 'VIEW:CMS_PENDING_EMBOSSED',
  'VIEW:CMS_CARD_INFO' = 'VIEW:CMS_CARD_INFO',
  'VIEW:CMS_CARD_FULL_NUMBER' = 'VIEW:CMS_CARD_FULL_NUMBER',
  'VIEW:CMS_CREDIT_LIMIT_BREAKDOWN' = 'VIEW:CMS_CREDIT_LIMIT_BREAKDOWN',
  'VIEW:DISPLAY_CARD_KYC_ADDRESS' = 'VIEW:DISPLAY_CARD_KYC_ADDRESS',
  'VIEW:CARD_FRAUD_SYSTEM' = 'VIEW:CARD_FRAUD_SYSTEM',
  'VIEW:RELATIONSHIP_MANAGER' = 'VIEW:RELATIONSHIP_MANAGER',
  'VIEW:ASSET_VALUE_CONFIG' = 'VIEW:ASSET_VALUE_CONFIG',
  'VIEW:ASSET_VALUE_CONFIG_OVERRIDE' = 'VIEW:ASSET_VALUE_CONFIG_OVERRIDE',
  'VIEW:CMS_CARD_FIXED_LIMIT' = 'VIEW:CMS_CARD_FIXED_LIMIT',
  'VIEW:CMS_CARD_ACCOUNT' = 'VIEW:CMS_CARD_ACCOUNT',
  'VIEW:EXCHANGE' = 'VIEW:EXCHANGE',
  'VIEW:CLIENT_DOCUMENT' = 'VIEW:CLIENT_DOCUMENT',
  'VIEW:RATE_SOURCE' = 'VIEW:RATE_SOURCE',
  'VIEW:INVOICE' = 'VIEW:INVOICE',
  'VIEW:EARN_OFFER' = 'VIEW:EARN_OFFER',
  'VIEW:EARN_POSITION' = 'VIEW:EARN_POSITION',
  'VIEW:EARN_SUBSCRIPTION' = 'VIEW:EARN_SUBSCRIPTION',
  'VIEW:EARN_PROVIDER' = 'VIEW:EARN_PROVIDER',
  'VIEW:PURCHASE_ORDER' = 'VIEW:PURCHASE_ORDER',
  'VIEW:USER_PENDING_CRA_FORM' = 'VIEW:USER_PENDING_CRA_FORM',
  'VIEW:RATE_REFERENCE' = 'VIEW:RATE_REFERENCE',
  'VIEW:USER_RISK_PROFILE' = 'VIEW:USER_RISK_PROFILE',
  'VIEW:ACCOUNT_ACTIVITY_RISK_REVIEW' = 'VIEW:ACCOUNT_ACTIVITY_RISK_REVIEW',
  'VIEW:FEE_COST' = 'VIEW:FEE_COST',
  'VIEW:FEE_MARKUP' = 'VIEW:FEE_MARKUP',
  'VIEW:FEE_PAYOUT' = 'VIEW:FEE_PAYOUT',
  'VIEW:USER_GROUP' = 'VIEW:USER_GROUP',
  'VIEW:FEE_SETTING_PREVIEW' = 'VIEW:FEE_SETTING_PREVIEW',
  'VIEW:ALL_INSTRUCTION' = 'VIEW:ALL_INSTRUCTION',
  'VIEW:SCHEDULED_INSTRUCTION' = 'VIEW:SCHEDULED_INSTRUCTION',
  'VIEW:REMARK' = 'VIEW:REMARK',
  'VIEW:TAG_MANAGEMENT' = 'VIEW:TAG_MANAGEMENT',
  'VIEW:CASE' = 'VIEW:CASE',
  'VIEW:NFT' = 'VIEW:NFT',
  'VIEW:WALLET_ACCOUNTS' = 'VIEW:WALLET_ACCOUNTS',
  'VIEW:FEE_SCHEDULE' = 'VIEW:FEE_SCHEDULE',
  'VIEW:COBRAND_FEE_SCHEDULE' = 'VIEW:COBRAND_FEE_SCHEDULE',
  'VIEW:NAME_CHECK' = 'VIEW:NAME_CHECK',
  'VIEW:CARD_NAME_CHECK' = 'VIEW:CARD_NAME_CHECK',
  'VIEW:BANK_ACCOUNTS' = 'VIEW:BANK_ACCOUNTS',
  'VIEW:OPERATIONAL_ACCOUNTS' = 'VIEW:OPERATIONAL_ACCOUNTS',
  'ACTION:ADD_OPERATIONAL_ACCOUNTS' = 'ACTION:ADD_OPERATIONAL_ACCOUNTS',
  'ACTION:EDIT_OPERATIONAL_ACCOUNTS' = 'ACTION:EDIT_OPERATIONAL_ACCOUNTS',
  'VIEW:USER_WELCOME_EMAIL' = 'VIEW:USER_WELCOME_EMAIL',
  'VIEW:SOLUTION_APPLICATION' = 'VIEW:SOLUTION_APPLICATION',
  'VIEW:RATE_BOARD' = 'VIEW:RATE_BOARD',
  'VIEW:CASH_IN_OUT' = 'VIEW:CASH_IN_OUT',
  'VIEW:WORLD_PAY' = 'VIEW:WORLD_PAY',
  'VIEW:BOOK_ENTRIES' = 'VIEW:BOOK_ENTRIES',
  'VIEW:LEDGER_ACCOUNT' = 'VIEW:LEDGER_ACCOUNT',
  'VIEW:JOURNAL_ENTRIES' = 'VIEW:JOURNAL_ENTRIES',
  'VIEW:BANK_AVAILABLE_BALANCE' = 'VIEW:BANK_AVAILABLE_BALANCE',
  'ACTION:PUBLISH_UTGL_TREASURY_SNAPSHOT' = 'ACTION:PUBLISH_UTGL_TREASURY_SNAPSHOT',
  'VIEW:ACCOUNTING_TAG' = 'VIEW:ACCOUNTING_TAG',
  'VIEW:SALES_REVENUE_SUMMARY' = 'VIEW:SALES_REVENUE_SUMMARY',
  'VIEW:REVENUE_BREAKDOWN' = 'VIEW:REVENUE_BREAKDOWN',
  'VIEW:COMMISSION_MANAGEMENT' = 'VIEW:COMMISSION_MANAGEMENT',
  'VIEW:OD_ACCOUNT' = 'VIEW:OD_ACCOUNT',
  'VIEW:UNIONPAY_REMITTANCE' = 'VIEW:UNIONPAY_REMITTANCE',
  'VIEW:ALIPAY_REMITTANCE' = 'VIEW:ALIPAY_REMITTANCE',
  'VIEW:AGENT_ONBOARDING' = 'VIEW:AGENT_ONBOARDING',
  'VIEW:CARD_INTEREST' = 'VIEW:CARD_INTEREST',
  'VIEW:COMMISSION_DETAILS' = 'VIEW:COMMISSION_DETAILS',
  'VIEW:CASH_POSITION_SUMMARY' = 'VIEW:CASH_POSITION_SUMMARY',
  'VIEW:PENDING_INSTRUCTION' = 'VIEW:PENDING_INSTRUCTION',
  'ACTION:EDIT_ACCOUNT_ACTIVATION' = 'ACTION:EDIT_ACCOUNT_ACTIVATION',
  'ACTION:EDIT_NAME_CHECK_ONGOING_SCREENING' = 'ACTION:EDIT_NAME_CHECK_ONGOING_SCREENING',
  'ACTION:CONFIGURE_NAME_CHECK_THRESHOLDS' = 'ACTION:CONFIGURE_NAME_CHECK_THRESHOLDS',
  // DIGITAL DEPOSIT
  'ACTION:REPROCESS_DIGITAL_DEPOSIT_PENDING' = 'ACTION:REPROCESS_DIGITAL_DEPOSIT_PENDING',
  'ACTION:DIGITAL_DEPOSIT_UPDATE_ORIGINATOR_INFO' = 'ACTION:DIGITAL_DEPOSIT_UPDATE_ORIGINATOR_INFO',
  'ACTION:RESYNC_DIGITAL_DEPOSIT' = 'ACTION:RESYNC_DIGITAL_DEPOSIT',
  'ACTION:DIGITAL_DEPOSIT_INITIATE_RETURN' = 'ACTION:DIGITAL_DEPOSIT_INITIATE_RETURN',

  // GENERAL_INSTRUCTION
  'ACTION:IMPORT_GENERAL_INSTRUCTION' = 'ACTION:IMPORT_GENERAL_INSTRUCTION',
  'ACTION:UPLOAD_GENERAL_INSTRUCTION' = 'ACTION:UPLOAD_GENERAL_INSTRUCTION',
  'ACTION:CREATE_GENERAL_INSTRUCTION' = 'ACTION:CREATE_GENERAL_INSTRUCTION',
  'ACTION:UPDATE_GENERAL_INSTRUCTION' = 'ACTION:UPDATE_GENERAL_INSTRUCTION',
  'ACTION:PROCESS_GENERAL_INSTRUCTION' = 'ACTION:PROCESS_GENERAL_INSTRUCTION',
  'ACTION:COMPLETE_GENERAL_INSTRUCTION' = 'ACTION:COMPLETE_GENERAL_INSTRUCTION',
  'ACTION:SUBMIT_GENERAL_INSTRUCTION' = 'ACTION:SUBMIT_GENERAL_INSTRUCTION',
  'ACTION:BATCH_UPDATE_GENERAL_INSTRUCTION' = 'ACTION:BATCH_UPDATE_GENERAL_INSTRUCTION',
  'ACTION:BATCH_PROCESS_GENERAL_INSTRUCTION' = 'ACTION:BATCH_PROCESS_GENERAL_INSTRUCTION',
  'ACTION:BATCH_COMPLETE_GENERAL_INSTRUCTION' = 'ACTION:BATCH_COMPLETE_GENERAL_INSTRUCTION',
  'ACTION:BATCH_CANCEL_GENERAL_INSTRUCTION' = 'ACTION:BATCH_CANCEL_GENERAL_INSTRUCTION',
  'ACTION:BATCH_SUBMIT_GENERAL_INSTRUCTION' = 'ACTION:BATCH_SUBMIT_GENERAL_INSTRUCTION',
  'ACTION:REPROCESS_GENERAL_INSTRUCTION' = 'ACTION:REPROCESS_GENERAL_INSTRUCTION',
  'ACTION:CANCEL_GENERAL_INSTRUCTION' = 'ACTION:CANCEL_GENERAL_INSTRUCTION',
  'ACTION:REJECT_GENERAL_INSTRUCTION' = 'ACTION:REJECT_GENERAL_INSTRUCTION',
  'ACTION:APPROVE_GENERAL_INSTRUCTION' = 'ACTION:APPROVE_GENERAL_INSTRUCTION',
  'ACTION:DOWNLOAD_GENERAL_INSTRUCTION' = 'ACTION:DOWNLOAD_GENERAL_INSTRUCTION',
  'ACTION:DOWNLOAD_PENDING_INSTRUCTION_REPORT' = 'ACTION:DOWNLOAD_PENDING_INSTRUCTION_REPORT',
  'ACTION:UNHEDGE_FX' = 'ACTION:UNHEDGE_FX',
  // KYC
  'ACTION:UPLOAD_KYC_DOCUMENT' = 'ACTION:UPLOAD_KYC_DOCUMENT',
  'ACTION:PROCESS_KYC_DOCUMENT' = 'ACTION:PROCESS_KYC_DOCUMENT',
  'ACTION:PROCESS_KYC' = 'ACTION:PROCESS_KYC',
  'ACTION:EDIT_KYC_LEVEL' = 'ACTION:EDIT_KYC_LEVEL',
  'ACTION:IMPERSONATE' = 'ACTION:IMPERSONATE',
  'ACTION:MANAGE_RESTRICTED_CLIENT' = 'ACTION:MANAGE_RESTRICTED_CLIENT',
  'ACTION:IMPERSONATE_RESTRICTED_CLIENT' = 'ACTION:IMPERSONATE_RESTRICTED_CLIENT',
  'ACTION:BYPASS_RESTRICTED_CLIENT_ACCESS' = 'ACTION:BYPASS_RESTRICTED_CLIENT_ACCESS',
  'ACTION:DEVELOPER_IMPERSONATE_PREVIEW' = 'ACTION:DEVELOPER_IMPERSONATE_PREVIEW',
  'ACTION:CREATE_INVITATION_CODE' = 'ACTION:CREATE_INVITATION_CODE',
  'ACTION:CREATE_USER' = 'ACTION:CREATE_USER',
  'ACTION:EDIT_USER_RISK_PROFILE' = 'ACTION:EDIT_USER_RISK_PROFILE',
  'ACTION:EDIT_USER_PROFILE' = 'ACTION:EDIT_USER_PROFILE',
  'ACTION:EDIT_USER_CARDHOLDER' = 'ACTION:EDIT_USER_CARDHOLDER',
  'ACTION:UPDATE_RELATIONSHIP_MANAGER' = 'ACTION:UPDATE_RELATIONSHIP_MANAGER',
  'ACTION:EDIT_USER_CONTACT' = 'ACTION:EDIT_USER_CONTACT',
  'ACTION:EDIT_USER_SUMMARY' = 'ACTION:EDIT_USER_SUMMARY',
  'ACTION:EDIT_USER_STATEMENT_OPTIONS' = 'ACTION:EDIT_USER_STATEMENT_OPTIONS',
  'ACTION:REFRESH_USER_FEATURE' = 'ACTION:REFRESH_USER_FEATURE',
  'ACTION:APPLY_NEW_FEE_SCHEDULE' = 'ACTION:APPLY_NEW_FEE_SCHEDULE',
  'ACTION:EDIT_DEPOSIT_ADDRESS' = 'ACTION:EDIT_DEPOSIT_ADDRESS',
  'ACTION:RESET_USER_PASSWORD' = 'ACTION:RESET_USER_PASSWORD',
  'ACTION:RESET_2FA' = 'ACTION:RESET_2FA',
  'ACTION:DISABLE_LOGIN_TFA' = 'ACTION:DISABLE_LOGIN_TFA',
  'ACTION:SEND_EMAIL_TO_USER' = 'ACTION:SEND_EMAIL_TO_USER',
  'ACTION:EDIT_USER_BENEFICIARIES' = 'ACTION:EDIT_USER_BENEFICIARIES',
  'ACTION:EDIT_USER_STATUS' = 'ACTION:EDIT_USER_STATUS',
  'ACTION:PROCESS_FIAT_DEPOSIT' = 'ACTION:PROCESS_FIAT_DEPOSIT',
  'ACTION:PROCESS_FIAT_WITHDRAW' = 'ACTION:PROCESS_FIAT_WITHDRAW',
  'ACTION:UPDATE_FIAT_DEPOSIT' = 'ACTION:UPDATE_FIAT_DEPOSIT',
  'ACTION:UPDATE_FIAT_WITHDRAW' = 'ACTION:UPDATE_FIAT_WITHDRAW',
  'ACTION:PROCESS_DIGITAL_WITHDRAW' = 'ACTION:PROCESS_DIGITAL_WITHDRAW',
  'ACTION:RESET_STUCK_DIGITAL_WITHDRAW' = 'ACTION:RESET_STUCK_DIGITAL_WITHDRAW',
  'ACTION:PROCESS_DIGITAL_DEPOSIT' = 'ACTION:PROCESS_DIGITAL_DEPOSIT',
  'ACTION:PROCESS_TRANSFER' = 'ACTION:PROCESS_TRANSFER',
  'ACTION:CREATE_BILL_PAYMENT' = 'ACTION:CREATE_BILL_PAYMENT',
  'ACTION:UPDATE_BILL_PAYMENT' = 'ACTION:UPDATE_BILL_PAYMENT',
  'ACTION:PROCESS_BILL_PAYMENT' = 'ACTION:PROCESS_BILL_PAYMENT',
  'ACTION:COMPLETE_BILL_PAYMENT' = 'ACTION:COMPLETE_BILL_PAYMENT',
  'ACTION:CANCEL_BILL_PAYMENT' = 'ACTION:CANCEL_BILL_PAYMENT',
  'ACTION:IMPORT_SECURITIES' = 'ACTION:IMPORT_SECURITIES',
  'ACTION:IMPORT_STATEMENTS' = 'ACTION:IMPORT_STATEMENTS',
  'ACTION:CREATE_SECURITIES_ACCOUNT' = 'ACTION:CREATE_SECURITIES_ACCOUNT',
  'ACTION:EDIT_SECURITIES_MANUAL' = 'ACTION:EDIT_SECURITIES_MANUAL',
  'ACTION:MANAGE_SECURITIES_BROKERS' = 'ACTION:MANAGE_SECURITIES_BROKERS',
  'ACTION:CREATE_INSURANCE_POLICY' = 'ACTION:CREATE_INSURANCE_POLICY',
  'ACTION:EDIT_INSURANCE_POLICY' = 'ACTION:EDIT_INSURANCE_POLICY',
  'ACTION:CREATE_OPERATOR' = 'ACTION:CREATE_OPERATOR',
  'ACTION:EDIT_OPERATOR_YOTP' = 'ACTION:EDIT_OPERATOR_YOTP',
  'ACTION:EDIT_OPERATOR_PERMISSION' = 'ACTION:EDIT_OPERATOR_PERMISSION',
  'ACTION:EDIT_OPERATOR_VENDOR' = 'ACTION:EDIT_OPERATOR_VENDOR',
  'ACTION:EDIT_OPERATOR_USER_GROUPS' = 'ACTION:EDIT_OPERATOR_USER_GROUPS',
  'ACTION:UNLOCK_OPERATOR' = 'ACTION:UNLOCK_OPERATOR',
  'ACTION:CREATE_CMS_CARD_PRODUCT' = 'ACTION:CREATE_CMS_CARD_PRODUCT',
  'ACTION:UPDATE_CMS_CARD_PRODUCT' = 'ACTION:UPDATE_CMS_CARD_PRODUCT',
  'ACTION:WHITELIST_COBRAND_CARD_PRODUCTS' = 'ACTION:WHITELIST_COBRAND_CARD_PRODUCTS',
  'ACTION:CMS_CARD_CANCEL' = 'ACTION:CMS_CARD_CANCEL',
  'ACTION:CMS_CARD_REPLACE' = 'ACTION:CMS_CARD_REPLACE',
  'ACTION:CMS_CARD_ISSUE' = 'ACTION:CMS_CARD_ISSUE',
  'ACTION:CMS_CREDIT_ENABLE_SECURED' = 'ACTION:CMS_CREDIT_ENABLE_SECURED',
  'ACTION:CMS_CARD_MAILED' = 'ACTION:CMS_CARD_MAILED',
  'ACTION:CREATE_RELATIONSHIP_MANAGER' = 'ACTION:CREATE_RELATIONSHIP_MANAGER',
  'ACTION:EDIT_RELATIONSHIP_MANAGER' = 'ACTION:EDIT_RELATIONSHIP_MANAGER',
  'ACTION:CMS_CARD_ACTIVATION' = 'ACTION:CMS_CARD_ACTIVATION',
  'ACTION:CMS_CARD_REPAYMENT' = 'ACTION:CMS_CARD_REPAYMENT',
  'ACTION:CMS_CARD_FIXED_LIMIT' = 'ACTION:CMS_CARD_FIXED_LIMIT',
  'ACTION:TOPUP_CREDIT' = 'ACTION:TOPUP_CREDIT',
  'ACTION:CMS_CARD_DAILY_LIMIT' = 'ACTION:CMS_CARD_DAILY_LIMIT',
  'ACTION:CMS_CARD_SUSPENSION' = 'ACTION:CMS_CARD_SUSPENSION',
  'ACTION:CMS_CARD_CHANGE_PASSCODE' = 'ACTION:CMS_CARD_CHANGE_PASSCODE',
  'ACTION:CMS_CARD_CHANGE_EMBOSSED_NAME' = 'ACTION:CMS_CARD_CHANGE_EMBOSSED_NAME',
  'ACTION:CMS_CARD_APPLICATION' = 'ACTION:CMS_CARD_APPLICATION',
  'ACTION:CMS_CARD_RENEWAL_DECISION' = 'ACTION:CMS_CARD_RENEWAL_DECISION',
  'ACTION:CMS_CARD_RENEWAL_ISSUE' = 'ACTION:CMS_CARD_RENEWAL_ISSUE',
  'ACTION:CMS_CARD_RENEWAL_ACTIVATE' = 'ACTION:CMS_CARD_RENEWAL_ACTIVATE',
  'ACTION:CMS_CARD_ANNUAL_FEE' = 'ACTION:CMS_CARD_ANNUAL_FEE',
  'ACTION:CMS_CARD_CLIENT_IDENTITIES_EDIT' = 'ACTION:CMS_CARD_CLIENT_IDENTITIES_EDIT',
  'ACTION:CMS_CARD_CLIENT_IDENTITIES_REJECT' = 'ACTION:CMS_CARD_CLIENT_IDENTITIES_REJECT',
  'ACTION:CMS_CARD_CLIENT_IDENTITIES_APPROVE' = 'ACTION:CMS_CARD_CLIENT_IDENTITIES_APPROVE',
  'VIEW:ISSUER_CARD_KYC' = 'VIEW:ISSUER_CARD_KYC',
  'ACTION:EDIT_ISSUER_CARD_KYC' = 'ACTION:EDIT_ISSUER_CARD_KYC',
  'ACTION:APPROVE_ISSUER_CARD_KYC' = 'ACTION:APPROVE_ISSUER_CARD_KYC',
  'ACTION:REJECT_ISSUER_CARD_KYC' = 'ACTION:REJECT_ISSUER_CARD_KYC',
  'ACTION:RECHECK_ISSUER_CARD_KYC' = 'ACTION:RECHECK_ISSUER_CARD_KYC',
  'ACTION:BYPASS_ISSUER_CARD_KYC' = 'ACTION:BYPASS_ISSUER_CARD_KYC',
  'VIEW:CARD_KYC_TRACKING' = 'VIEW:CARD_KYC_TRACKING',
  'ACTION:UPDATE_CARD_KYC_SUBMISSION' = 'ACTION:UPDATE_CARD_KYC_SUBMISSION',
  'ACTION:CMS_CREDIT_SET_CREDIT_LIMIT' = 'ACTION:CMS_CREDIT_SET_CREDIT_LIMIT',
  'ACTION:CMS_CREDIT_PLATFORM_REPAYMENT' = 'ACTION:CMS_CREDIT_PLATFORM_REPAYMENT',
  'ACTION:EDIT_ALTERNATIVES' = 'ACTION:EDIT_ALTERNATIVES',
  'ACTION:EDIT_CMS_CARD_PHONE' = 'ACTION:EDIT_CMS_CARD_PHONE',
  'ACTION:UPDATE_CARD_ACCOUNT_NAME' = 'ACTION:UPDATE_CARD_ACCOUNT_NAME',
  'ACTION:BOOK_CARD_ADJUSTMENT' = 'ACTION:BOOK_CARD_ADJUSTMENT',
  'ACTION:BOOK_PROGRAM_SETTLEMENT' = 'ACTION:BOOK_PROGRAM_SETTLEMENT',
  'ACTION:CMS_SET_PROGRAM_LIMIT' = 'ACTION:CMS_SET_PROGRAM_LIMIT',
  'VIEW:MANAGE_COLLATERAL' = 'VIEW:MANAGE_COLLATERAL',
  'ACTION:EDIT_CMS_AUTOPAY_ASSETS' = 'ACTION:EDIT_CMS_AUTOPAY_ASSETS',
  'ACTION:EDIT_CMS_CARD_LOCK' = 'ACTION:EDIT_CMS_CARD_LOCK',
  'ACTION:EDIT_CMS_CARD_UNLOCK' = 'ACTION:EDIT_CMS_CARD_UNLOCK',
  'ACTION:EDIT_CLIENT_DOCUMENT' = 'ACTION:EDIT_CLIENT_DOCUMENT',
  'ACTION:CREATE_CLIENT_DOCUMENT' = 'ACTION:CREATE_CLIENT_DOCUMENT',
  'ACTION:CREATE_INVOICE' = 'ACTION:CREATE_INVOICE',
  'ACTION:EDIT_INVOICE' = 'ACTION:EDIT_INVOICE',
  'ACTION:EDIT_PURCHASE_ORDER' = 'ACTION:EDIT_PURCHASE_ORDER',
  'ACTION:CREATE_PURCHASE_ORDER' = 'ACTION:CREATE_PURCHASE_ORDER',
  'ACTION:EDIT_CMS_CARD_APPLICATION_CANCEL' = 'ACTION:EDIT_CMS_CARD_APPLICATION_CANCEL',
  'ACTION:CREATE_TRANSFER' = 'ACTION:CREATE_TRANSFER',
  'ACTION:EXCHANGE' = 'ACTION:EXCHANGE',
  'ACTION:EDIT_WALLET_OVERDRAFT' = 'ACTION:EDIT_WALLET_OVERDRAFT',
  'ACTION:EDIT_USER_GROUP' = 'ACTION:EDIT_USER_GROUP',
  'ACTION:EDIT_FEE_COST' = 'ACTION:EDIT_FEE_COST',
  'ACTION:EDIT_FEE_MARKUP' = 'ACTION:EDIT_FEE_MARKUP',
  'ACTION:DELETE_FEE' = 'ACTION:DELETE_FEE',
  'ACTION:CANCEL_FEE' = 'ACTION:CANCEL_FEE',
  'ACTION:CHARGE_FEE' = 'ACTION:CHARGE_FEE',
  'ACTION:CLEANUP_ACCOUNT_CLOSURE_BALANCE' = 'ACTION:CLEANUP_ACCOUNT_CLOSURE_BALANCE',
  'ACTION:UPDATE_FEE' = 'ACTION:UPDATE_FEE',
  'ACTION:WAIVE_FEE' = 'ACTION:WAIVE_FEE',
  'ACTION:WAIVE_B2B_COST_FEE' = 'ACTION:WAIVE_B2B_COST_FEE',
  'ACTION:EDIT_RATE_SOURCE' = 'ACTION:EDIT_RATE_SOURCE',
  'ACTION:IMPORT_INSURANCE_POLICY' = 'ACTION:IMPORT_INSURANCE_POLICY',
  'ACTION:EDIT_REMARK' = 'ACTION:EDIT_REMARK',
  'ACTION:ASSIGN_BANK_ACCOUNT' = 'ACTION:ASSIGN_BANK_ACCOUNT',
  'ACTION:ENABLE_BANK_ACCOUNT' = 'ACTION:ENABLE_BANK_ACCOUNT',
  'ACTION:DISABLE_BANK_ACCOUNT' = 'ACTION:DISABLE_BANK_ACCOUNT',
  'ACTION:PROCESS_BANK_ACCOUNT' = 'ACTION:PROCESS_BANK_ACCOUNT',
  'ACTION:ENABLE_AUTO_CREDIT' = 'ACTION:ENABLE_AUTO_CREDIT',
  'ACTION:DISABLE_AUTO_CREDIT' = 'ACTION:DISABLE_AUTO_CREDIT',
  'ACTION:UPDATE_AUTO_CREDIT' = 'ACTION:UPDATE_AUTO_CREDIT',
  'ACTION:CREATE_TAG' = 'ACTION:CREATE_TAG',
  'ACTION:RENAME_TAG' = 'ACTION:RENAME_TAG',
  'ACTION:CASE_CHANGE_STATUS' = 'ACTION:CASE_CHANGE_STATUS',
  'ACTION:CASE_CHANGE_RESOLUTION' = 'ACTION:CASE_CHANGE_RESOLUTION',
  'ACTION:SET_USER_GROUPS' = 'ACTION:SET_USER_GROUPS',
  'ACTION:MANAGE_USER_MIGRATION_CAMPAIGN' = 'ACTION:MANAGE_USER_MIGRATION_CAMPAIGN',
  'ACTION:CMS_CARD_TRANSACTIONS_MARK_DISPUTE' = 'ACTION:CMS_CARD_TRANSACTIONS_MARK_DISPUTE',
  'ACTION:CMS_CARD_CHANGE_NOTIFICATION' = 'ACTION:CMS_CARD_CHANGE_NOTIFICATION',
  'ACTION:CARD_FRAUD_SYSTEM' = 'ACTION:CARD_FRAUD_SYSTEM',
  'ACTION:REVIEW_CRA_FORM' = 'ACTION:REVIEW_CRA_FORM',
  'ACTION:CMS_IMPORT_UNISSUED_CARD' = 'ACTION:CMS_IMPORT_UNISSUED_CARD',
  'ACTION:CARD_PRODUCT_REFRESH' = 'ACTION:CARD_PRODUCT_REFRESH',
  'ACTION:CMS_APPLY_LOAN_RATIO_CONFIG' = 'ACTION:CMS_APPLY_LOAN_RATIO_CONFIG',
  'ACTION:ADD_ASSET_VALUE_CONFIG_OVERRIDE' = 'ACTION:ADD_ASSET_VALUE_CONFIG_OVERRIDE',
  'ACTION:SAVE_ASSET_VALUE_CONFIG_OVERRIDE' = 'ACTION:SAVE_ASSET_VALUE_CONFIG_OVERRIDE',
  'ACTION:CREATE_ALTERNATIVES' = 'ACTION:CREATE_ALTERNATIVES',
  'ACTION:CREATE_WALLET_ACCOUNT' = 'ACTION:CREATE_WALLET_ACCOUNT',
  'ACTION:EDIT_WALLET_ACCOUNT' = 'ACTION:EDIT_WALLET_ACCOUNT',
  'ACTION:CREATE_TREASURY_DIGITAL_WHITELIST' = 'ACTION:CREATE_TREASURY_DIGITAL_WHITELIST',
  'ACTION:CREATE_EARN_OFFER' = 'ACTION:CREATE_EARN_OFFER',
  'ACTION:EDIT_EARN_OFFER' = 'ACTION:EDIT_EARN_OFFER',
  'ACTION:CREATE_EARN_PROVIDER' = 'ACTION:CREATE_EARN_PROVIDER',
  'ACTION:EDIT_EARN_PROVIDER' = 'ACTION:EDIT_EARN_PROVIDER',
  'ACTION:DELETE_EARN_PROVIDER' = 'ACTION:DELETE_EARN_PROVIDER',
  'ACTION:EDIT_NAME_CHECK' = 'ACTION:EDIT_NAME_CHECK',
  'ACTION:EDIT_CARD_NAME_CHECK' = 'ACTION:EDIT_CARD_NAME_CHECK',
  'ACTION:REFRESH_DEPOSIT_ADDRESSES' = 'ACTION:REFRESH_DEPOSIT_ADDRESSES',
  'ACTION:CREATE_CASH_INVENTORY' = 'ACTION:CREATE_CASH_INVENTORY',
  'ACTION:UPDATE_PAYMENT_DETAILS' = 'ACTION:UPDATE_PAYMENT_DETAILS',
  'ACTION:UPDATE_SOLUTION_APPLICATION_STATUS' = 'ACTION:UPDATE_SOLUTION_APPLICATION_STATUS',
  'ACTION:APPLY_SOLUTION_APPLICATION' = 'ACTION:APPLY_SOLUTION_APPLICATION',
  'ACTION:DOWNGRADE_SOLUTION_APPLICATION' = 'ACTION:DOWNGRADE_SOLUTION_APPLICATION',
  'ACTION:BYPASS_SANCTIONED_NATIONALITY_SOLUTION_APPLICATION' = 'ACTION:BYPASS_SANCTIONED_NATIONALITY_SOLUTION_APPLICATION',
  'ACTION:EDIT_RATE_BOARD' = 'ACTION:EDIT_RATE_BOARD',
  'ACTION:REQUEST_EXCHANGE' = 'ACTION:REQUEST_EXCHANGE',
  'ACTION:APPROVE_EXCHANGE' = 'ACTION:APPROVE_EXCHANGE',
  'ACTION:CANCEL_EXCHANGE' = 'ACTION:CANCEL_EXCHANGE',
  'ACTION:QUOTE_EXCHANGE' = 'ACTION:QUOTE_EXCHANGE',
  'ACTION:EXECUTE_EXCHANGE' = 'ACTION:EXECUTE_EXCHANGE',
  'ACTION:QUICK_EXCHANGE' = 'ACTION:QUICK_EXCHANGE',
  'ACTION:CUSTOM_RATE_EXCHANGE' = 'ACTION:CUSTOM_RATE_EXCHANGE',
  'ACTION:CUSTOM_PERCENT_EXCHANGE' = 'ACTION:CUSTOM_PERCENT_EXCHANGE',
  'ACTION:EDIT_SOLUTION_APPLICATION' = 'ACTION:EDIT_SOLUTION_APPLICATION',
  'ACTION:APPROVE_SOLUTION_APPLICATION' = 'ACTION:APPROVE_SOLUTION_APPLICATION',
  'ACTION:EDIT_BANK_ACCOUNTS_WHITELIST' = 'ACTION:EDIT_BANK_ACCOUNTS_WHITELIST',
  'ACTION:EDIT_EARN_SUBSCRIPTION' = 'ACTION:EDIT_EARN_SUBSCRIPTION',
  'ACTION:CREATE_EARN_SUBSCRIPTION' = 'ACTION:CREATE_EARN_SUBSCRIPTION',
  'ACTION:APPROVE_REQUESTED_EARN_SUBSCRIPTION' = 'ACTION:APPROVE_REQUESTED_EARN_SUBSCRIPTION',
  'ACTION:REJECT_REQUESTED_EARN_SUBSCRIPTION' = 'ACTION:REJECT_REQUESTED_EARN_SUBSCRIPTION',
  'ACTION:CANCEL_SCHEDULED_INSTRUCTION' = 'ACTION:CANCEL_SCHEDULED_INSTRUCTION',
  'ACTION:PROCESS_WORLD_PAY_SETTLEMENT' = 'ACTION:PROCESS_WORLD_PAY_SETTLEMENT',
  'ACTION:PROCESS_BOOK_ENTRIES' = 'ACTION:PROCESS_BOOK_ENTRIES',
  'ACTION:PROCESS_LEDGER_ACCOUNT' = 'ACTION:PROCESS_LEDGER_ACCOUNT',
  'ACTION:DELETE_LEDGER_ACCOUNT' = 'ACTION:DELETE_LEDGER_ACCOUNT',
  'ACTION:PROCESS_JOURNAL_ENTRIES' = 'ACTION:PROCESS_JOURNAL_ENTRIES',
  'ACTION:DELETE_NON_PLATFORM_JOURNAL' = 'ACTION:DELETE_NON_PLATFORM_JOURNAL',
  'ACTION:EDIT_ACCOUNTING_TAG' = 'ACTION:EDIT_ACCOUNTING_TAG',
  'ACTION:ADD_ACCOUNTING_TAG' = 'ACTION:ADD_ACCOUNTING_TAG',
  'ACTION:UPDATE_PENDING_COMMISSION' = 'ACTION:UPDATE_PENDING_COMMISSION',
  'ACTION:APPROVE_COMMISSION_UPDATES' = 'ACTION:APPROVE_COMMISSION_UPDATES',
  'ACTION:DISTRIBUTE_COMMISSION' = 'ACTION:DISTRIBUTE_COMMISSION',
  // Quota Update
  'ACTION:QUOTA_UPDATE_REQUEST' = 'ACTION:QUOTA_UPDATE_REQUEST',
  'ACTION:QUOTA_UPDATE_APPROVAL' = 'ACTION:QUOTA_UPDATE_APPROVAL',
  
  'ACTION:FEE_SCHEDULE_UPDATE_REQUEST' = 'ACTION:FEE_SCHEDULE_UPDATE_REQUEST',
  'ACTION:FEE_SCHEDULE_UPDATE_APPROVAL' = 'ACTION:FEE_SCHEDULE_UPDATE_APPROVAL',
  'ACTION:FEE_COMMISSION_UPDATE_REQUEST' = 'ACTION:FEE_COMMISSION_UPDATE_REQUEST',
  'ACTION:FEE_COMMISSION_UPDATE_APPROVAL' = 'ACTION:FEE_COMMISSION_UPDATE_APPROVAL',
  'ACTION:COBRAND_FEE_SCHEDULE_UPDATE_REQUEST' = 'ACTION:COBRAND_FEE_SCHEDULE_UPDATE_REQUEST',
  'ACTION:COBRAND_FEE_SCHEDULE_UPDATE_APPROVAL' = 'ACTION:COBRAND_FEE_SCHEDULE_UPDATE_APPROVAL',
  'ACTION:CMS_CARD_CHANGE_EMAIL' = 'ACTION:CMS_CARD_CHANGE_EMAIL',
  'ACTION:UNIONPAY_REMITTANCE' = 'ACTION:UNIONPAY_REMITTANCE',
  'ACTION:ALIPAY_REMITTANCE' = 'ACTION:ALIPAY_REMITTANCE',
  'ACTION:CMS_CREDIT_REFRESH_LIMIT' = 'ACTION:CMS_CREDIT_REFRESH_LIMIT',
  'ACTION:CREATE_ADDITIONAL_CARD_ACCOUNT' = 'ACTION:CREATE_ADDITIONAL_CARD_ACCOUNT',
  'VIEW:CMS_CARD_DISPUTES' = 'VIEW:CMS_CARD_DISPUTES',
  'VIEW:CMS_FORCE_POSTING' = 'VIEW:CMS_FORCE_POSTING',
  'ACTION:CMS_FORCE_POSTING_PCS_UPDATE' = 'ACTION:CMS_FORCE_POSTING_PCS_UPDATE',
  'VIEW:CMS_CARD_BALANCES' = 'VIEW:CMS_CARD_BALANCES',
  'ACTION:CUPD_MISMATCH_SYNC' = 'ACTION:CUPD_MISMATCH_SYNC',
  'ACTION:DOWNLOAD_SENSITIVE_CARD_REPORT' = 'ACTION:DOWNLOAD_SENSITIVE_CARD_REPORT',

  //card factory
  'VIEW:CARD_FACTORY_BATCH' = 'VIEW:CARD_FACTORY_BATCH',
  'ACTION:UPDATE_CARD_FACTORY_BATCH' = 'ACTION:UPDATE_CARD_FACTORY_BATCH',
  'ACTION:CMS_CREDIT_ACCOUNT_FREEZE' = 'ACTION:CMS_CREDIT_ACCOUNT_FREEZE',
  'ACTION:CMS_CREDIT_ACCOUNT_UNFREEZE' = 'ACTION:CMS_CREDIT_ACCOUNT_UNFREEZE',
  'ACTION:CHARGE_CARD_INTEREST' = 'ACTION:CHARGE_CARD_INTEREST',
  'ACTION:WAIVE_CARD_INTEREST' = 'ACTION:WAIVE_CARD_INTEREST',
  'VIEW:TRANSFER_PEER' = 'VIEW:TRANSFER_PEER',
  // Legacy "edit any transfer peer" — retained for the approval drawer + bank-account review flows.
  // New Counterparties management uses the per-type ACTION:EDIT_COUNTERPARTY_<TYPE> grants below.
  'ACTION:EDIT_TRANSFER_PEER' = 'ACTION:EDIT_TRANSFER_PEER',
  'ACTION:EDIT_COUNTERPARTY_BANK_ACCOUNT' = 'ACTION:EDIT_COUNTERPARTY_BANK_ACCOUNT',
  'ACTION:EDIT_COUNTERPARTY_BANK_ACCOUNT_V2' = 'ACTION:EDIT_COUNTERPARTY_BANK_ACCOUNT_V2',
  'ACTION:EDIT_COUNTERPARTY_PAYEE' = 'ACTION:EDIT_COUNTERPARTY_PAYEE',
  'ACTION:EDIT_COUNTERPARTY_MERCHANT' = 'ACTION:EDIT_COUNTERPARTY_MERCHANT',
  'ACTION:EDIT_COUNTERPARTY_DIGITAL_ADDRESS' = 'ACTION:EDIT_COUNTERPARTY_DIGITAL_ADDRESS',
  'ACTION:EDIT_COUNTERPARTY_ORIGINATOR_DIGITAL_ADDRESS' = 'ACTION:EDIT_COUNTERPARTY_ORIGINATOR_DIGITAL_ADDRESS',
  'ACTION:EDIT_COUNTERPARTY_UNIONPAY' = 'ACTION:EDIT_COUNTERPARTY_UNIONPAY',
  'ACTION:EDIT_COUNTERPARTY_ALIPAY' = 'ACTION:EDIT_COUNTERPARTY_ALIPAY',
  'ACTION:EDIT_COUNTERPARTY_CASH_PICKUP' = 'ACTION:EDIT_COUNTERPARTY_CASH_PICKUP',
  'ACTION:EDIT_COUNTERPARTY_CASH_DROP_OFF' = 'ACTION:EDIT_COUNTERPARTY_CASH_DROP_OFF',
  'ACTION:EDIT_COUNTERPARTY_PEER_ACCOUNT' = 'ACTION:EDIT_COUNTERPARTY_PEER_ACCOUNT',
  'ACTION:EDIT_COUNTERPARTY_ACCOUNT' = 'ACTION:EDIT_COUNTERPARTY_ACCOUNT',
  'ACTION:EDIT_COUNTERPARTY_PRECIOUS_METAL_WITHDRAWAL' = 'ACTION:EDIT_COUNTERPARTY_PRECIOUS_METAL_WITHDRAWAL',
  'ACTION:SYNC_CLIENT_STORE_DATA' = 'ACTION:SYNC_CLIENT_STORE_DATA',

  // Risk Profile
  'VIEW:RISK_PROFILE' = 'VIEW:RISK_PROFILE',
  'ACTION:EDIT_RISK_PROFILE' = 'ACTION:EDIT_RISK_PROFILE',
  'ACTION:REVIEW_RISK_PROFILE' = 'ACTION:REVIEW_RISK_PROFILE',

  // Precious metal
  'VIEW:PRECIOUS_METAL_PRODUCT' = 'VIEW:PRECIOUS_METAL_PRODUCT',
  'ACTION:PRECIOUS_METAL_PRODUCT_EDIT' = 'ACTION:PRECIOUS_METAL_PRODUCT_EDIT',
  'ACTION:PRECIOUS_METAL_PRODUCT_CREATE' = 'ACTION:PRECIOUS_METAL_PRODUCT_CREATE',
  'VIEW:PRECIOUS_METAL_INSTRUCTION' = 'VIEW:PRECIOUS_METAL_INSTRUCTION',
  'ACTION:PRECIOUS_METAL_BUY_PROCESS_INSTRUCTION' = 'ACTION:PRECIOUS_METAL_BUY_PROCESS_INSTRUCTION',
  'ACTION:PRECIOUS_METAL_BUY_COMPLETE_INSTRUCTION' = 'ACTION:PRECIOUS_METAL_BUY_COMPLETE_INSTRUCTION',
  'ACTION:PRECIOUS_METAL_WITHDRAWAL_PROCESS_INSTRUCTION' = 'ACTION:PRECIOUS_METAL_WITHDRAWAL_PROCESS_INSTRUCTION',
  'ACTION:PRECIOUS_METAL_WITHDRAWAL_COMPLETE_INSTRUCTION' = 'ACTION:PRECIOUS_METAL_WITHDRAWAL_COMPLETE_INSTRUCTION',
  'ACTION:PRECIOUS_METAL_WITHDRAWAL_GENERATE_ACKNOWLEDGEMENT' = 'ACTION:PRECIOUS_METAL_WITHDRAWAL_GENERATE_ACKNOWLEDGEMENT',
  'ACTION:PRECIOUS_METAL_WITHDRAWAL_CREATE_INSTRUCTION' = 'ACTION:PRECIOUS_METAL_WITHDRAWAL_CREATE_INSTRUCTION',
  'VIEW:CMS_NOTIFICATION_LOG' = 'VIEW:CMS_NOTIFICATION_LOG',
  'VIEW:CMS_OOB_NOTIFICATION_LOG' = 'VIEW:CMS_OOB_NOTIFICATION_LOG',
  'VIEW:TRIBE_TAI_NOTIFICATION' = 'VIEW:TRIBE_TAI_NOTIFICATION',
  'ACTION:RESEND_TRIBE_TAI_NOTIFICATION' = 'ACTION:RESEND_TRIBE_TAI_NOTIFICATION',
  'ACTION:REPROCESS_TRIBE_TAI_WEBHOOK' = 'ACTION:REPROCESS_TRIBE_TAI_WEBHOOK',
  'ACTION:REFRESH_LEDGER_ACCOUNT_BALANCE' = 'ACTION:REFRESH_LEDGER_ACCOUNT_BALANCE',
  'VIEW:PRECIOUS_METAL_POSITION' = 'VIEW:PRECIOUS_METAL_POSITION',

  // Cashier
  'ACTION:DOWNLOAD_CASH_RECONCILE_REPORT' = 'ACTION:DOWNLOAD_CASH_RECONCILE_REPORT',
  'ACTION:BATCH_TRANSFER' = 'ACTION:BATCH_TRANSFER',
  'ACTION:GENERATE_BALANCE_CERTIFICATE' = 'ACTION:GENERATE_BALANCE_CERTIFICATE',
  // Journal Report
  'ACTION:JOURNAL_REPORT' = 'ACTION:JOURNAL_REPORT',
  // Support Center
  'VIEW:SUPPORT_CENTER' = 'VIEW:SUPPORT_CENTER',
  'VIEW:SUPPORT_CENTER_COMMENT' = 'VIEW:SUPPORT_CENTER_COMMENT',
  'VIEW:SUPPORT_CENTER_MY_REQUEST' = 'VIEW:SUPPORT_CENTER_MY_REQUEST',
  'VIEW:SUPPORT_CENTER_TEAM_BOARD' = 'VIEW:SUPPORT_CENTER_TEAM_BOARD',
  'VIEW:SUPPORT_CENTER_REQUEST_DETAILS' = 'VIEW:SUPPORT_CENTER_REQUEST_DETAILS',
  'ACTION:UPDATE_SUPPORT_CENTER' = 'ACTION:UPDATE_SUPPORT_CENTER',
  'ACTION:UPDATE_OPERATOR' = 'ACTION:UPDATE_OPERATOR',
  'ACTION:COMPLETE_CHANGE_BENEFICIARIES' = 'ACTION:COMPLETE_CHANGE_BENEFICIARIES',
  // IFAST Fund
  'VIEW:IFAST_INSTRUCTION_LIST' = 'VIEW:IFAST_INSTRUCTION_LIST',
  'VIEW:IFAST_POSITION_LIST' = 'VIEW:IFAST_POSITION_LIST',
  'VIEW:IFAST_ACCOUNT_LIST' = 'VIEW:IFAST_ACCOUNT_LIST',
  'ACTION:EDIT_IFAST_INSTRUCTION' = 'ACTION:EDIT_IFAST_INSTRUCTION',

  // Steward AI

  // Blacklist Merchant
  'VIEW:BLACKLIST_MERCHANT' = 'VIEW:BLACKLIST_MERCHANT',
  'ACTION:CREATE_BLACKLIST_MERCHANT' = 'ACTION:CREATE_BLACKLIST_MERCHANT',
  'ACTION:UPDATE_BLACKLIST_MERCHANT' = 'ACTION:UPDATE_BLACKLIST_MERCHANT',
  'ACTION:TOGGLE_BLACKLIST_MERCHANT' = 'ACTION:TOGGLE_BLACKLIST_MERCHANT',
  'ACTION:DELETE_TMS_BLACKLIST' = 'ACTION:DELETE_TMS_BLACKLIST',
  // Card Merchant Whitelist
  'VIEW:CARD_MERCHANT_WHITELIST' = 'VIEW:CARD_MERCHANT_WHITELIST',
  'ACTION:CREATE_CARD_MERCHANT_WHITELIST' = 'ACTION:CREATE_CARD_MERCHANT_WHITELIST',
  'ACTION:UPDATE_CARD_MERCHANT_WHITELIST' = 'ACTION:UPDATE_CARD_MERCHANT_WHITELIST',
  'ACTION:TOGGLE_CARD_MERCHANT_WHITELIST' = 'ACTION:TOGGLE_CARD_MERCHANT_WHITELIST',
  'ACTION:DELETE_TMS_WHITELIST' = 'ACTION:DELETE_TMS_WHITELIST',
  // Compliance Cases
  'VIEW:COMPLIANCE_CASE' = 'VIEW:COMPLIANCE_CASE',
  'ACTION:CREATE_COMPLIANCE_CASE' = 'ACTION:CREATE_COMPLIANCE_CASE',
  'ACTION:ASSIGN_COMPLIANCE_CASE' = 'ACTION:ASSIGN_COMPLIANCE_CASE',
  'ACTION:ESCALATE_COMPLIANCE_CASE' = 'ACTION:ESCALATE_COMPLIANCE_CASE',
  'ACTION:COLLECT_EDD' = 'ACTION:COLLECT_EDD',
  'ACTION:UPLOAD_EVIDENCE' = 'ACTION:UPLOAD_EVIDENCE',
  'ACTION:PROPOSE_RESOLUTION' = 'ACTION:PROPOSE_RESOLUTION',
  'ACTION:APPROVE_RESOLUTION' = 'ACTION:APPROVE_RESOLUTION',
  'ACTION:BATCH_RESOLVE_COMPLIANCE_CASE' = 'ACTION:BATCH_RESOLVE_COMPLIANCE_CASE',
  'ACTION:LINK_CASE_INTENT' = 'ACTION:LINK_CASE_INTENT',
  'ACTION:MANAGE_CASE_SUBJECTS' = 'ACTION:MANAGE_CASE_SUBJECTS',
  'ACTION:MANAGE_COMPLIANCE_RULES' = 'ACTION:MANAGE_COMPLIANCE_RULES',
  'ACTION:EDIT_INVESTIGATION_NOTES' = 'ACTION:EDIT_INVESTIGATION_NOTES',
  'ACTION:ADD_CASE_NOTE' = 'ACTION:ADD_CASE_NOTE',
  // UniGroup Book Management
  'VIEW:UNIGROUP_BOOK_MANAGEMENT' = 'VIEW:UNIGROUP_BOOK_MANAGEMENT',
  'ACTION:EDIT_UNIGROUP_BOOK_MANAGEMENT' = 'ACTION:EDIT_UNIGROUP_BOOK_MANAGEMENT',

  // Gift Card Batch
  'ACTION:CMS_GIFT_CARD_BATCH' = 'ACTION:CMS_GIFT_CARD_BATCH',
  'ACTION:CMS_CARD_IMPORT' = 'ACTION:CMS_CARD_IMPORT',

  // Fuel Sweep
  'VIEW:DIGITAL_ASSET_TREASURY' = 'VIEW:DIGITAL_ASSET_TREASURY',
  'VIEW:DIGITAL_ASSET_TREASURY_STATS' = 'VIEW:DIGITAL_ASSET_TREASURY_STATS',
  'ACTION:CREATE_TREASURY_REQUEST' = 'ACTION:CREATE_TREASURY_REQUEST',
  'ACTION:CANCEL_TREASURY_TASK' = 'ACTION:CANCEL_TREASURY_TASK',
  'ACTION:RETRY_TREASURY_TASK' = 'ACTION:RETRY_TREASURY_TASK',
  'ACTION:CREATE_AUTO_TRANSFER' = 'ACTION:CREATE_AUTO_TRANSFER',
  'ACTION:UPDATE_AUTO_TRANSFER' = 'ACTION:UPDATE_AUTO_TRANSFER',
  'ACTION:DELETE_AUTO_TRANSFER' = 'ACTION:DELETE_AUTO_TRANSFER',
  'ACTION:TRIGGER_AUTO_TRANSFER' = 'ACTION:TRIGGER_AUTO_TRANSFER',
  // Fuel Sweep Tenants
  'ACTION:CREATE_TREASURY_TENANT' = 'ACTION:CREATE_TREASURY_TENANT',
  'ACTION:UPDATE_TREASURY_TENANT' = 'ACTION:UPDATE_TREASURY_TENANT',
  // TRON Delegations
  'VIEW:TRON_DELEGATIONS' = 'VIEW:TRON_DELEGATIONS',
  'ACTION:MANAGE_TRON_DELEGATIONS' = 'ACTION:MANAGE_TRON_DELEGATIONS',
  // Vault Top-Up Rules
  'ACTION:CREATE_TOPUP_RULE' = 'ACTION:CREATE_TOPUP_RULE',
  'ACTION:UPDATE_TOPUP_RULE' = 'ACTION:UPDATE_TOPUP_RULE',
  'ACTION:DELETE_TOPUP_RULE' = 'ACTION:DELETE_TOPUP_RULE',
  'ACTION:TRIGGER_TOPUP_RULE' = 'ACTION:TRIGGER_TOPUP_RULE',

  // Vendor Config
  'VIEW:VENDOR_CONFIG' = 'VIEW:VENDOR_CONFIG',
  'ACTION:EDIT_VENDOR_CONFIG' = 'ACTION:EDIT_VENDOR_CONFIG',

  // What's New
  'VIEW:APP_DISCLOSURE' = 'VIEW:APP_DISCLOSURE',
  'ACTION:EDIT_APP_DISCLOSURE' = 'ACTION:EDIT_APP_DISCLOSURE',
  'ACTION:PUBLISH_APP_DISCLOSURE' = 'ACTION:PUBLISH_APP_DISCLOSURE',
  'VIEW:APP_WHATS_NEW' = 'VIEW:APP_WHATS_NEW',
  'ACTION:EDIT_APP_WHATS_NEW' = 'ACTION:EDIT_APP_WHATS_NEW',
  // App important notices
  'VIEW:APP_IMPORTANT_NOTICES' = 'VIEW:APP_IMPORTANT_NOTICES',
  'ACTION:EDIT_APP_IMPORTANT_NOTICES' = 'ACTION:EDIT_APP_IMPORTANT_NOTICES',
  'VIEW:APP_CARD_OFFERS' = 'VIEW:APP_CARD_OFFERS',
  'ACTION:EDIT_APP_CARD_OFFERS' = 'ACTION:EDIT_APP_CARD_OFFERS',

  // Support Center – Client Issues
  'VIEW:SUPPORT_CENTER_CLIENT_ISSUE' = 'VIEW:SUPPORT_CENTER_CLIENT_ISSUE',
  'ACTION:CREATE_CLIENT_ISSUE' = 'ACTION:CREATE_CLIENT_ISSUE',
  'ACTION:MANAGE_ISSUE_ACTIONS' = 'ACTION:MANAGE_ISSUE_ACTIONS',
  'ACTION:MANAGE_ISSUE_CATEGORIES' = 'ACTION:MANAGE_ISSUE_CATEGORIES',
  'VIEW:ISSUE_CATEGORY_ANALYTICS' = 'VIEW:ISSUE_CATEGORY_ANALYTICS',

  // Secret Management (DevOps only)
  'VIEW:SECRET_MANAGEMENT' = 'VIEW:SECRET_MANAGEMENT',
  'ACTION:EDIT_SECRET_MANAGEMENT' = 'ACTION:EDIT_SECRET_MANAGEMENT',

  // System Notice Email
  'VIEW:SYSTEM_NOTICE_EMAIL' = 'VIEW:SYSTEM_NOTICE_EMAIL',
  'ACTION:SEND_SYSTEM_NOTICE_EMAIL' = 'ACTION:SEND_SYSTEM_NOTICE_EMAIL',
  'VIEW:SYSTEM_NOTICE_EMAIL_HISTORY' = 'VIEW:SYSTEM_NOTICE_EMAIL_HISTORY',
  // Welcome Email Template
  'VIEW:WELCOME_EMAIL_TEMPLATE' = 'VIEW:WELCOME_EMAIL_TEMPLATE',
  'ACTION:EDIT_WELCOME_EMAIL_TEMPLATE' = 'ACTION:EDIT_WELCOME_EMAIL_TEMPLATE',
  // CS Telegram Bot
  'VIEW:CS_TELEGRAM_BOT' = 'VIEW:CS_TELEGRAM_BOT',
  'ACTION:EDIT_CS_TELEGRAM_BOT' = 'ACTION:EDIT_CS_TELEGRAM_BOT',
  'ACTION:SEND_CS_TELEGRAM_BOT_BROADCAST' = 'ACTION:SEND_CS_TELEGRAM_BOT_BROADCAST',
  'ACTION:LEAVE_CS_TELEGRAM_BOT_GROUPS' = 'ACTION:LEAVE_CS_TELEGRAM_BOT_GROUPS',
  'ACTION:REVERT_CS_TELEGRAM_BOT_BROADCAST' = 'ACTION:REVERT_CS_TELEGRAM_BOT_BROADCAST',
  // Feature flag rules
  'VIEW:FEATURE_FLAG_RULES' = 'VIEW:FEATURE_FLAG_RULES',
  'ACTION:CREATE_FEATURE_FLAG' = 'ACTION:CREATE_FEATURE_FLAG',
  'ACTION:EDIT_FEATURE_FLAG_RULES' = 'ACTION:EDIT_FEATURE_FLAG_RULES',
  'ACTION:EDIT_FEATURE_FLAG_RULE_RAW_JSON' = 'ACTION:EDIT_FEATURE_FLAG_RULE_RAW_JSON',

  // PI Qualification
  'VIEW:PI_QUALIFICATION' = 'VIEW:PI_QUALIFICATION',
  'ACTION:REVIEW_PI_QUALIFICATION' = 'ACTION:REVIEW_PI_QUALIFICATION',
  'ACTION:REVOKE_PI_QUALIFICATION' = 'ACTION:REVOKE_PI_QUALIFICATION',
  'ACTION:UPDATE_PI_QUALIFICATION' = 'ACTION:UPDATE_PI_QUALIFICATION',
  
  // Client Consent
  'VIEW:CLIENT_CONSENT' = 'VIEW:CLIENT_CONSENT',
  'ACTION:CREATE_CLIENT_CONSENT' = 'ACTION:CREATE_CLIENT_CONSENT',
  'ACTION:UPDATE_CLIENT_CONSENT' = 'ACTION:UPDATE_CLIENT_CONSENT',
  'ACTION:EXPORT_CLIENT_CONSENT' = 'ACTION:EXPORT_CLIENT_CONSENT',

  // Card Quota
  'VIEW:CARD_QUOTA' = 'VIEW:CARD_QUOTA',

  // Audit Logs
  'VIEW:AUDIT_LOG' = 'VIEW:AUDIT_LOG',
  'ACTION:EXPORT_AUDIT_LOG' = 'ACTION:EXPORT_AUDIT_LOG',
  'ACTION:VERIFY_AUDIT_LOG' = 'ACTION:VERIFY_AUDIT_LOG',

  // PDF Template (AcroForm vendor blanks)
  'VIEW:PDF_TEMPLATE' = 'VIEW:PDF_TEMPLATE',
  'ACTION:UPLOAD_PDF_TEMPLATE' = 'ACTION:UPLOAD_PDF_TEMPLATE',
  'ACTION:APPROVE_PDF_TEMPLATE' = 'ACTION:APPROVE_PDF_TEMPLATE',
  'ACTION:PUBLISH_PDF_TEMPLATE' = 'ACTION:PUBLISH_PDF_TEMPLATE'
}
export interface Acl {
  [ModuleName: string]: Array<{
    permission: PermissionVerbAction;
    allow: boolean;
  }>;
}

export function isPermitted<T extends ModuleName>(
  moduleName: T,
  verbAction: PermissionVerbAction = PermissionVerbAction['ACTION:*'],
  acl?: Acl
) {
  if (!acl) {
    return false;
  }
  const modulePermissions = acl[moduleName] ?? [];
  const globalPermissions = acl['*'] ?? [];
  if (verbAction) {
    const [verb] = verbAction.toString().split(':');
    // return true if get full permission on all module
    if (!!globalPermissions.find((p) => p.permission === `${verb}:*` && p.allow === true)) {
      return true;
    }
    // return true if get full permission on chosen module
    if (!!modulePermissions.find((p) => p.permission === `${verb}:*` && p.allow === true)) {
      return true;
    }
    // return true if get module ACTION permission
    if (!!modulePermissions.find((p) => p.permission === verbAction && p.allow === true)) {
      return true;
    }
  }
  return false;
}

export function hasSomeMultiplePermitted<T extends ModuleName>(moduleNamesAndVerbActionArray: [T, PermissionVerbAction][], acl?: Acl) {
  return moduleNamesAndVerbActionArray.some(([moduleName, verbAction]) => isPermitted(moduleName, verbAction, acl));
}

/**
 * Authorized component - wraps children and conditionally renders based on permissions.
 * When the permission overlay is enabled (developer tool), shows visual indicators.
 */
export function Authorized(props: { children: any; module: ModuleName; verbAction?: PermissionVerbAction }) {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  const { enabled: overlayEnabled, showUnauthorized } = usePermissionOverlay();

  const permitted = isPermitted(props.module, props.verbAction, currentUser?.acl);

  // When overlay is enabled, use PermissionBadge for visual indication
  if (overlayEnabled) {
    return (
      <PermissionBadge
        module={props.module}
        verbAction={props.verbAction}
        isAuthorized={permitted}
      >
        {props.children}
      </PermissionBadge>
    );
  }

  // Normal behavior: render children if permitted, null otherwise
  if (permitted) {
    return props.children;
  } else {
    return null;
  }
}

export default (props: { module: ModuleName; verbAction: PermissionVerbAction }) => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};

  const permitted = isPermitted(props.module, props.verbAction, currentUser.acl);

  return (Component: any, redirectComp?: any) => {
    if (permitted) {
      return Component;
    } else {
      if (redirectComp) {
        return redirectComp;
      }
      return () => (
        <div>
          <h1>Not Authorized</h1>You are not authorized to view this section.
        </div>
      );
    }
  };
};
